import { render, staticRenderFns } from "./IcoStar.vue?vue&type=template&id=2b38a704"
import script from "./IcoStar.vue?vue&type=script&lang=js"
export * from "./IcoStar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports